module.exports = __webpack_public_path__ + "img/pinganshun-android.6b113af0.png";